// libs
import React, {useEffect, useState} from 'react'
import Pagination from "react-js-pagination";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// components
import Navigation from "../../components/navbar";
import FormModal from './form-modal';
import "../../assets/css/style.css";
import BreadcrumbNav from "../../components/breadcrumb-nav";
import Loading from '../../components/loading';
import Table from './table';
import Record404 from '../../components/record404';
import PrintErrorMsg from '../../components/print-error-msg';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from '../../config';
import utils from '../../utils';
import { useSelectedAccount } from '../../context/account-context';
import { navigateListPageUrl } from '../../utils/list-page-url';

function List({token, orgInfo}) {
	let query = utils.useQuery();
	const { selectedAccountId, hasSelectedAccount } = useSelectedAccount();
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
	const [ListData, setListData] = useState([]);
	const [TotalListCount, setTotalListCount] = useState(0);
	const [IsLoading, setIsLoading] = useState(true);
	const [IsError, setIsError] = useState(true);
	const [Is404, setIs404] = useState(false);
	const [SearchQInputVal, setSearchQInputVal] = useState(null);

	let paginationNo = query.get("page");
	let urlSearchQ = query.get("searchQ");
	let activePage = (utils.isNumeric(paginationNo)) ? parseInt(paginationNo) : 1;
	let offset = (activePage*config.pagination.limitPerPage)-config.pagination.limitPerPage;

	const handleChangeSearchQuery = (event) => {
		setSearchQInputVal(event.target.value);
	}

	const handlePageChange = (pageNumber) => {
		navigateListPageUrl(selectedAccountId, { set: { page: pageNumber } });
	}

	const submitSearchQuery = () => {
		navigateListPageUrl(selectedAccountId, {
			set: { searchQ: SearchQInputVal },
			remove: ['page'],
		});
	}

	const loadApiData = async (loadOffset) => {
		setIsLoading(true);
		if(hasSelectedAccount) {
			let apiCall = await ajaxCall.getCall(`${config.api.generic}/shipping-price`, {
				offset: loadOffset,
				limit: config.pagination.limitPerPage,
				fAccount: selectedAccountId,
				fSearchQ: urlSearchQ
			}, token, {"Domain": "vyayata"});
			if(apiCall && apiCall.status) {
				setListData(apiCall.context.message.data.records);
				setTotalListCount(apiCall.context.message.data.totalCount);
				setIsLoading(false);
				setIsError(null);
				setIs404(false);
			} else {
				setIsLoading(false);
				setIs404(true);
				setIsError(null);
			}
		} else {
			setIsLoading(false);
			setIs404(false);
			setIsError("Choose a seller account in the top navigation to begin.");
		}
    }

	const LoadTable = () => {
		if(IsLoading) {
			return <Loading />
		} else if (Is404) {
			return <Record404 />
		} else if (IsError) {
			return <PrintErrorMsg msg={IsError} />
		} else {
			return <Table loadapidata={loadApiData} offset={offset} list={ListData} urlAccountId={selectedAccountId} orgInfo={orgInfo} token={token} paginationNo={paginationNo} />
		}
	}

	useEffect(() => {
		loadApiData((offset == 1) ? 0 : offset);
	}, [selectedAccountId, urlSearchQ, paginationNo]);

	return (
		<>
			<Navigation orgInfo={orgInfo} />
			<Container>
				<Row>
					<Col>
                        <div className="mt-3">
                            <h3 className="fs-20rem text-left vt-txt-dark-blue">Shipping Pincode</h3>
                            <BreadcrumbNav list={[{label: 'Home', url: '/'}, {label: `Shipping - (${TotalListCount})`, url: false}]} />
                        </div>
                    </Col>
                    <Col>
                        <div className="text-right d-flex justify-content-end h-100 align-items-center">
                            <Button variant="primary" type="button" size="md" disabled={!hasSelectedAccount} onClick={() => setShowFormModalBox(true)} className="vt-primary-btn border-0 text-white fs-14rem">ADD SHIPPING RULE</Button>
                        </div>
                    </Col>
                    <hr />
				</Row>
				<Row>
					<Col md="5" lg="4" className="mb-3">
						<div><label className="form-label fs-13rem fw-bold">Search</label></div>
						<div className="input-group">
							<input type="text" className="form-control" defaultValue={urlSearchQ} onKeyUp={handleChangeSearchQuery} placeholder="Search" aria-label="Search" />
							<div className="input-group-append">
								<Button variant="secondary" className="btn text-white btn-outline-secondary rounded-0" onClick={submitSearchQuery} type="button" disabled={!hasSelectedAccount}>Search</Button>
							</div>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<LoadTable />
					</Col>
				</Row>
				<Row>
					<Col>
						<div className="d-flex justify-content-center my-2">
							<Pagination
								activePage={activePage}
								itemsCountPerPage={config.pagination.limitPerPage}
								totalItemsCount={parseInt(TotalListCount)}
								pageRangeDisplayed={5}
								onChange={(e) => handlePageChange(e)}
								innerClass="pagination"
								itemClass="page-item"
								linkClass="page-link"
								activeClass="active"
							/>
						</div>
					</Col>
				</Row>
			</Container>
			{(ShowFormModalBox) ? <FormModal loadapidata={loadApiData} apidataparams={(offset == 1) ? 0 : offset} setshowformmodalbox={setShowFormModalBox} orgaccountid={selectedAccountId} token={token} orginfo={orgInfo} /> : null}
		</>
	)
}

export default List;
